/*
 * Company Teams Grid — migrated from Sprockets company_teams/table_view.js
 * AG Grid v35 APIs
 */
window.CompanyTeamsGrid = {
    _gridApi: null,
    _gridOptions: null,

    initialize(tableSelector, highLevelMembership, data, key) {
        let columnDefs = [
            { headerName: I18n.t('name'), field: 'name', cellClass: 'cell', filter: 'agTextColumnFilter' },
            { headerName: I18n.t('job_title'), field: 'job_title', cellClass: 'cell', filter: 'agSetColumnFilter' },
            { headerName: I18n.t('office'), field: 'office', cellClass: 'cell', filter: 'agTextColumnFilter' }
        ];

        if (highLevelMembership) {
            columnDefs = columnDefs.concat([
                { headerName: I18n.t('simple_form.placeholders.employment.email'), field: 'email', cellClass: 'cell', filter: 'agTextColumnFilter' },
                { headerName: I18n.t('simple_form.placeholders.employment.direct_phone'), field: 'direct_phopne', cellClass: 'cell', filter: 'agNumberColumnFilter' },
                { headerName: I18n.t('simple_form.placeholders.employment.person.mobile'), field: 'mobile', cellClass: 'cell', filter: 'agTextColumnFilter' },
                { headerName: I18n.t('simple_form.placeholders.employment.person.linkedin_url'), field: 'linkedin_url', cellClass: 'hyperlinks', filter: 'agTextColumnFilter' }
            ]);
        }

        this._gridOptions = {
            paginationPageSize: 10,
            headerHeight: 44,
            rowHeight: 44,
            rowData: data,
            suppressPaginationPanel: true,
            columnDefs: columnDefs,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            defaultExcelExportParams: {
                autoConvertFormulas: true,
                processCellCallback: params => {
                    const field = params.column.getColDef().field;
                    return field === 'linkedin_url' ? `=HYPERLINK("${params.value}")` : params.value;
                }
            },
            excelStyles: [
                { id: 'hyperlinks', font: { underline: 'Single', color: '#358ccb' } }
            ],
            onGridSizeChanged(event) {
                return event.api.sizeColumnsToFit();
            },
            onGridReady(event) {
                return event.api.sizeColumnsToFit();
            }
        };

        const gridDiv = document.getElementById(tableSelector);
        this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
        this._gridOptions.api = this._gridApi;
        resizeAgGridTable(`#${tableSelector}`, this._gridOptions, 1);
        this._gridApi.sizeColumnsToFit();
    },

    export() {
        this._gridApi.exportDataAsExcel();
    }
};
